<fgb-mobile-page-header [pageTitle]="'mobile.page.activity.header.title'" [backButtonLink]="'/'" />
<ng-container *ifScreenSize="screenType.Desktop">
  <fgb-banner [title]="'account.activity.page.title' | translate" />
</ng-container>

<div class="container mobile-container">
  <fgb-account-nav></fgb-account-nav>
  <div class="pt-4">
    <div class="points-history">
      <fgb-transaction-history [transactionTypes]="[transactionTypes.loyalty]" [accountView]="true"></fgb-transaction-history>
    </div>
  </div>
</div>
